export const IconMainUser: {
  name: 'icon_main_user-6f60f3019290'
} = {
  name: 'icon_main_user-6f60f3019290'
}
